/**
 * Filtro che restituisce il nodo del situationRecordTypesTree dato il valore di clazz
 */
'use strict';
module.exports = (['situationRecordService', function (situationRecordService) {
        var ret = undefined;
        return function (clazz, situationRecordTypesTree) {
            ret = undefined;
            if (clazz) {
                if (!situationRecordTypesTree){
                    //se non ho passato l'albero faccio la chiamata al server
                    //TODO: TESTARE
                    situationRecordService.situationRecordGetTypes(function (res) {
                        situationRecordTypesTree = res.children;

                    });
                }
                
                angular.forEach(situationRecordTypesTree, function (node) {
                    if (!ret) {
                        findSituationRecordTypeLoop(clazz, node);
                    }
                });
            }

            return ret;
        };

        function findSituationRecordTypeLoop(element, node) {
            if (!ret) {
                if (node.element === element) {
                    ret = node;

                    return;
                } else
                {
                    angular.forEach(node.children, function (n) {
                        if (node.children.length > 0) {
                            findSituationRecordTypeLoop(element, n);
                        } else
                            return;
                    });
                }
            }
        }
        ;
    }]);





//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-AstralSituationRecord/components/filters/clazzNodeFilter.js
// module id = 279
// module chunks = 0